<template>
    <div class="row row-rtl row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
        <div
            v-for="asset in rows"
            :key="asset.id"
            class="col mb-4"
        >
            <div class="card mb-4">
                <img
                    v-if="asset.image_filename"
                    :src="`${asset.image_url_download}?w=300`"
                    class="card-img-top"
                    :alt="asset.name"
                    loading="lazy"
                >

                <div class="card-body text-end text-dark">
                    <h5 class="card-title">
                        {{ asset.name }}
                    </h5>

                    <p>
                        <small
                            class="card-text"
                            v-html="asset.description"
                        >
                        </small>
                    </p>

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <a
                                v-if="asset.presentation_filename"
                                :href="asset.presentation_url_download"
                                class="btn btn-primary w-100"
                                title="تنزيل الصور"
                            >
                                تنزيل الصور
                            </a>
                        </div>

                        <div class="col-12 col-md-6">
                            <a
                                :href="asset.lesson_url_download"
                                class="btn btn-primary w-100"
                                title="تنزيل الدروس"
                            >
                                تنزيل الدروس
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            rows: [],
        };
    },

    mounted: function () {
        axios({
            method: 'get',
            url: '/api/arabic-assets',
        })
        .then((response) => {
            this.rows = response.data;
        });
    },
};
</script>
